import React, { useState, useEffect, lazy, Suspense } from "react";
import { Box, CircularProgress } from "@mui/material";
import { useSelector } from "react-redux";
import { Stack, InputLabel } from "@mui/material";
import IconButton from "@mui/material/IconButton";
import CheckCircleIcon from "@mui/icons-material/CheckCircle";
import CameraAltIcon from "@mui/icons-material/CameraAlt";
import { Dialog, DialogTitle, DialogContent, DialogActions, Button } from "@mui/material";
import BaseButton from "../../UI/BaseButton/BaseButton";
import Input from "../../UI/Input/Input";
import { CRMDepositFunds, DepositQRCodeConfirm } from "../../../util/API/transfer";
import Select from "../../UI/Select/Select";
import { getExternalAccounts } from "../../../util/API/transfers";
import CustomAlert from "../../UI/CustomAlert/CustomAlert";
import PinPad from "../../PinPad/PinPad";
import { setUserID } from "../../../store/redux/users";
import { useDispatch } from "react-redux";
import { getReceipts } from "../../../util/API/transfer";
import { countryList } from "../../../constants/countrylist";
import { getErrorMessage, getErrorMessage2 } from "../../../util/utilfunctions/utilFunctions";

const LazyQrScanner = lazy(() => import("react-qr-scanner"));


function QRCodeDeposit() {

    const [amount, setAmount] = useState("");
    const [accounts, setAccounts] = useState([]);
    const [userInformation, setUserInformation] = useState({
        name: "",
        userID: ""
    });
    const [selectInformation, setSelectInformation] = useState({
        value: "",
        options: [],
        show: false
    })
    const [alert, setAlert] = useState({
        open: false,
        message: "",
        severity: "success",
        header: "Success"
    })
    const [showPinPad, setShowPinPad] = useState(false);
    const [receipt, setReceipt] = useState({
        showReceipt: false,
        receiptIDData: {}
    });
    const [countdown, setCountdown] = useState(null);
    // const [disabled, setDisabled] = useState(false);
    const [qrCode, setQrCode] = useState("");
    const [showQRScanner, setShowQRScanner] = useState(false);
    const [disableAmount, setDisableAmount] = useState(true);
    const parentuserid = sessionStorage.getItem("parentuserid");
    const [isLoading, setIsLoading] = useState(false);

    let isOperator = sessionStorage.getItem("isOperator");
    let configVariables = useSelector((state) => state.config.baseConfig);
    let isAutoRetry;

useEffect(() => {
  if (disableAmount === false) {
    setCountdown(90);
    const interval = setInterval(() => {
      setCountdown((prev) => {
        if (prev === 1) {
          clearInterval(interval);
          setDisableAmount(true);
          setSelectInformation({
            value: "",
            options: [],
            show: false
          })
          return null;
        }
        return prev - 1;
      });
    }, 1000);

    return () => clearInterval(interval); // Clean up on unmount or re-run
  }
}, [disableAmount]);

    const scanBarcode = () => {
      setShowQRScanner(true);
    }
    
    let pin = sessionStorage.getItem("pin");
    let agent = JSON.parse(sessionStorage.getItem("user")).payload.body;
    let user = useSelector((state) => state.usersList.userID);
    const pinConfiguration = useSelector((state) => state.login.pinConfiguration);

    const dispatch = useDispatch();

    const handleConfirm = (event, pin) => {
    let PIN = pin.join('');
    handleQRCodeDeposit(event, PIN);
    setShowPinPad(false);
  };

  const handleScan = (data) => {
    if (data) {
      setQrCode(data.text);
      setShowQRScanner(false);
    }
  };

  const handleError = (error) => {
    console.error("QR scanner error:", error);

    setShowQRScanner(false);

    setAlert({
      open: true,
      message: "Failed to scan QR code",
      severity: "error",
      header: "Error",
    });
  };

  useEffect(() => {
    getAccounts(userInformation.userID)
  }, [receipt.showReceipt])

  const handleQRCodeDeposit = async(e, pin) => {
    // console.log(amount)
    // console.log(pin)
    // console.log(user)

    setReceipt({...receipt, showReceipt: false});

    if (!amount) {
      setAlert({
        open: true,
        message: "Please input an amount to be deposited",
        severity: "error",
        header: "Error!",
      });
      return;
    }

    try {
      setIsLoading(true);
      const response = await CRMDepositFunds(
        accounts.filter((account) => account.Vtransfersourcepis.id === selectInformation.value)[0]['Vtransfersourcepis'].id, // transaction account
        countryList.filter((country) => country.value === user['User'].countryid)[0]?.label, // user['User'].countryid, // user
        user['User'].firstName, // user
        user['User'].lastName, // user
        user['User'].telephoneno, // user
        accounts.filter((account) => account.Vtransfersourcepis.id === selectInformation.value)[0]['Vtransfersourcepis'].userid, // transaction account
        parseFloat(amount), // value
        amount, // total
        user['User'].langID, // user
        user['User'].accountID, // user
        user['User'].address1, // user
        user['User'].address2, // user
        user['User'].cityname, // user
        pin, // pin
        agent['User'].id, // agent
        agent['User'].firstName, // agent
        agent['User'].lastName, // agent
        agent['User'].cityname, // agent
        countryList.filter((country) => country.value === agent['User'].countryid)[0]?.label, // agent
        parentuserid,
        isOperator
      )
  
      if(response.Status === "1") {
        setAlert({
          open: true,
          message: "Deposit Completed",
          severity: "success",
          header: "Congratulations!"
        })
        if (pinConfiguration === "once") {
          sessionStorage.setItem("pin", pin);
        }
        setReceipt({...receipt, showReceipt: true, receiptIDData: response});
        setAmount("");
        setUserInformation({
          ...userInformation,
          name: "",
          userID: ""
        })
        setSelectInformation({
          ...selectInformation,
          value: "",
          show: false
        })
        setQrCode("")
      }
        else {
          const errorMsg = getErrorMessage2(response, isAutoRetry = false);
          // const errorMsg = getErrorMessage(response);
          setAlert({
            open: true,
            message: "Deposit Failed: " + errorMsg,
            severity: "error",
            header: "Error!"
          })
        }
    } catch (error) {
      
    } finally {
      setIsLoading(false);
    }

    // console.log(accounts)
    
  };

  // console.log(receipt)

  const getAccounts = async(id) => {
    const response2 = await getExternalAccounts(id)
        // console.log(response2)
  
        if (response2.callStatus == "1") {

          setAccounts(response2.ServiceData.record);

          const accountOptions = response2.ServiceData.record
            .filter((account) => account.Vtransfersourcepis.piid === "229")
            .map((account) => ({
              key: account.Vtransfersourcepis.acctID,
              value: account.Vtransfersourcepis.id,
              label: `${account.Vtransfersourcepis.friendlyname} - ${account.Vtransfersourcepis.currcode} ${account.Vtransfersourcepis.balance}`,
          }));

          // console.log(accountOptions)

          setSelectInformation({
            ...selectInformation,
            options: accountOptions,
            show: true
          })
        }
  }

  const verifyQRCode = async() => {
    if (!qrCode) {
      setAlert({
        open: true,
        message: "Please input a valid QR code",
        severity: "error",
        header: "Error!",
      });
      return;
    }

      const response = await DepositQRCodeConfirm(qrCode)
      // console.log(response)

      dispatch(setUserID({ userID: response.ServiceData }));
  
      if (response.callStatus === "1") {
        setUserInformation({
          ...userInformation,
          name: response.ServiceData.User.firstName + " " + response.ServiceData.User.lastName,
          userID: response.ServiceData.User.id
        });
  
        getAccounts(response.ServiceData.User.id);

        setDisableAmount(false);
  
      }
      else {
        setAlert({
          open: true,
          message: `${response.payload.msg}`,
          severity: "error",
          header: "Error!",
        });
      }
  }

  useEffect(() => {
    if (selectInformation.options.length > 0) {
      setSelectInformation({
        ...selectInformation,
        value: selectInformation.options[0].value
      })
    }
  })

  const handleReceipt = async (event) => {
    try{
      const response = await getReceipts(
        receipt.receiptIDData.forCustomer.trngrpid
      ).then((response) => {
        console.log(response)
        // window.open("https://dev2.4pay.ca/portal/www/php/Workflows/mod_genreceipt.php?type=deposit&id=" + response.ServiceData.Transreceipt.groupID, "_blank");
        window.open(configVariables.baseURL + 
          configVariables.receiptExtension + 
          "/mod_genreceipt.php?type=deposit&id=" + 
          response.ServiceData.Transreceipt.groupID, "_blank"
        );
      })
    }
    catch(error){
      console.log(error);
    }
  };

  const handleDepositClick = () => {
    if (!amount || parseFloat(amount) === 0) {
      setAlert({
        open: true,
        message: "Please enter a value greater than 0 to be deposited",
        severity: "error",
        header: "Error!",
      });
      return;
    }

    setShowPinPad(true);
  }

    return (
      <>
      {isLoading == true ? (
        <Box
            sx={{
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
                width: "100%",
                overflow: "hidden",
            }}
        >
            <CircularProgress />
        </Box>
      ) : (
        <>
        <InputLabel 
          sx={{
            fontWeight: '800', 
            lineHeight: '33.6px',
            color: '#6b7280',
            fontFamily: 'Nunito',
            fontSize: '14px',
            fontStyle: 'normal',
          }}
        >
          QR Code
        </InputLabel>

        <Stack direction="row" alignItems="center" spacing={1}>
            <Input
                name="qrcode"
                value={qrCode}
                type="string"
                textAlign="left"
                onChange={(e) => setQrCode(e.target.value)}
            />
            <Stack direction="row" spacing={1} alignItems="center">
                <IconButton
                sx={{
                    backgroundColor: 'green',
                    color: 'white',
                    height: '35px',  
                    width: '35px',    
                    padding: 0,       
                    margin: '15px',
                    borderRadius: '4px', 
                    '& .MuiSvgIcon-root': { 
                    fontSize: '20px',
                    },
                    '&:hover': {
                    backgroundColor: 'darkgreen',
                    },
                }}
                onClick={() => { verifyQRCode() }}
                >
                  {/* <CheckCircleIcon /> */}
                  {disableAmount ? (
                    <CheckCircleIcon />
                  ) : (
                    <Box sx={{ fontSize: '12px', fontWeight: 'bold', color: 'white' }}>
                      {countdown}s
                    </Box>
                  )}
                </IconButton>
                <IconButton
                sx={{
                    backgroundColor: 'gray',
                    color: 'white',
                    height: '35px',  
                    width: '35px',    
                    padding: 0,       
                    borderRadius: '4px', 
                    '& .MuiSvgIcon-root': {
                    fontSize: '20px',
                    },
                    '&:hover': {
                    backgroundColor: 'darkgray',
                    },
                }}
                onClick={() => { scanBarcode() }}
                >
                  <CameraAltIcon />
                </IconButton>
            </Stack>
        </Stack>

        {selectInformation.show && <Box className="info-box">
            <Box className="sender-name justify-content-end gap-2 align-items-center">
              <InputLabel sx={{
              fontWeight: '800', 
              lineHeight: '33.6px',
              color: '#6b7280',
              fontFamily: 'Nunito',
              fontSize: '14px',
              fontStyle: 'normal',
              }}>
              Recipient Name
              </InputLabel>
              <Box className="info-box-info">{`${userInformation.name} [${userInformation.userID}]`}</Box>
            </Box>

            <Select
              name="myselect"
              label="Select Claim Option"
              value={selectInformation?.value}
              onChange={(e) => setSelectInformation({...selectInformation, value: e.target.value})}
              options={selectInformation?.options}
            />
        </Box>}

        <Input
        name="depositAmount"
        label="Amount"
        value={amount}
        type="string"
        textAlign="right"
        onChange={(e) => setAmount(e.target.value)}
        disabled={disableAmount}
        />

        <Stack spacing={1} direction="row" className="button-group d-flex justify-content-end mt-3">
            <BaseButton 
                buttonText={"Deposit"} 
                onClick={(e) => {{pin ? handleQRCodeDeposit(e, pin) : pinConfiguration === "never" ? handleQRCodeDeposit(e, '0000') : handleDepositClick()}}}
            />
            {receipt.showReceipt ? <BaseButton 
                buttonText={"Receipt"} 
                buttonStyle="secondary-button-style"
                onClick={() => {handleReceipt()}}
            /> : null}
        </Stack>
        </>
      )}
        <Dialog
          open={showQRScanner}
          onClose={() => setShowQRScanner(false)} // Close modal when clicking outside or Escape key
          maxWidth="sm"
          fullWidth
        >
          <DialogTitle>
            QR Scanner
            <IconButton
              aria-label="close"
              onClick={() => setShowQRScanner(false)}
              sx={{
                position: 'absolute',
                right: 8,
                top: 8,
                color: (theme) => theme.palette.grey[500],
              }}
            >
              <span style={{ fontSize: "1.5rem" }}>×</span>
            </IconButton>
          </DialogTitle>
          <DialogContent dividers>
            {/* <QrScanner
              delay={300}
              onError={handleError}
              onScan={handleScan}
              style={{ width: "100%" }}
            /> */}
            <Suspense fallback={<div>Loading QR Scanner...</div>}>
              <LazyQrScanner
                delay={300}
                onError={handleError}
                onScan={handleScan}
                style={{ width: "100%" }}
              />
            </Suspense>
          </DialogContent>
          <DialogActions>
            <Button onClick={() => setShowQRScanner(false)}>Close</Button>
          </DialogActions>
        </Dialog>
        <CustomAlert 
          severity={alert.severity} 
          show={alert.open} 
          header={alert.header} 
          message={alert.message} 
          onClick={() => { setAlert({...alert, open: false})}} 
          autoclose={alert.severity === "error" ? false : true} 
        />
        {showPinPad && 
          <PinPad 
            show={showPinPad} 
            handleConfirm={handleConfirm} 
            onClick={() => setShowPinPad(false)} 
          />
        }     
      </>
    )
}

export default QRCodeDeposit;